import { UsersService } from "@/common/api.service";
import { FETCH_USER_DATA, FETCH_INDIVIDUAL_USER_DATA, UPDATE_USER_DATA, CREATE_USER_DATA, RESET_STATE, PATIENT_ALERT_FORWARD_EMAIL, PATIENT_ALERT_ADD_NOTES } from "./actions.type";
import { SET_USER_DATA, SET_INDIVIDUAL_USER_DATA, SET_USER_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    userdata: [],
    individualuserdata: [],
    usererror: [],
  }
};

export const state = initialState();

const actions ={

  async [FETCH_USER_DATA](context, slug) {
    return await UsersService.get(slug).then(({ data }) => {
      context.commit(SET_USER_DATA, data.data)
      return data
    }).catch(({ response }) =>{
      context.commit(SET_USER_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_INDIVIDUAL_USER_DATA](context, slug) {
    return await UsersService.get(slug).then(({ response }) => {
      context.commit(SET_INDIVIDUAL_USER_DATA, response.data)
      return response
    }).catch(({ response })=>{
      context.commit(SET_USER_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [CREATE_USER_DATA](context, slug) {
    return await UsersService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({response})=>{
      context.commit(SET_USER_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [UPDATE_USER_DATA](context, slug) {
    return await UsersService.update(slug).then((response) => {
      return response
    }).catch(({ response })=>{
      context.commit(SET_USER_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [PATIENT_ALERT_FORWARD_EMAIL](context, slug) {
    return await UsersService.update(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({ response }) => {
      context.commit(SET_USER_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [PATIENT_ALERT_ADD_NOTES](context, slug) {
    return await UsersService.update(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({ response }) => {
      context.commit(SET_USER_ERROR, response.data.errorMessage)
      return response
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_USER_DATA](state, userdata) {
    state.userdata = userdata
  },
  [SET_INDIVIDUAL_USER_DATA](state, individualuser) {
    state.individualuserdata = individualuser
  },
  [SET_USER_ERROR](state, error) {
    state.usererror = error
  },  
  [STATE_RESET](state) {
    Object.assign(state,initialState())
  }

}

const getters = {
  
  userdata(state) {
    return state.userdata;
  },
  individualuserdata(state) {
    return state.individualuserdata;
  },

}

export default {
    state,
    getters,
    actions,
    mutations
};